module.exports = __webpack_public_path__ + "img/at-a-time.4f7868fe.gif";